<template>
  <div class="align-middle d-print-none align-items-baseline">

    <router-link :to="{name:'UserWallets',params:{user:$store.getters['User/getProfile'].id}}">
      <b-btn size="sm" class="align-items-baseline" pill>
       مدیریت کیف پول
      </b-btn>
    </router-link>

  </div>
</template>

<script>
import {walletValue} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "widget",
  methods: {
    walletValue,
    formatNumber
  },
}
</script>

<style>
.plus-icon-font-size {
  font-size: 20px;
}
</style>